import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Features.css';

const Features = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const features = [
    {
      icon: 'fas fa-robot',
      title: 'AI Trading Coach',
      description: 'Have a question about your trade? Ask your personal AI coach. It reviews your data to provide tailored advice and answers instantly.',
      gradient: 'linear-gradient(135deg, #00D4FF, #66E5FF)'
    },
    {
      icon: 'fas fa-chart-area',
      title: 'AI Chart Analysis',
      description: 'Upload your charts and get deep technical analysis. Our AI identifies patterns, support/resistance levels, and potential setups automatically.',
      gradient: 'linear-gradient(135deg, #bd00ff, #00D4FF)'
    },
    {
      icon: 'fas fa-book-open',
      title: 'Smart Journaling',
      description: 'Effortlessly log trades using voice or text. Reflect on your psychology and execution to build discipline and consistency.',
      gradient: 'linear-gradient(135deg, #FF0099, #bd00ff)'
    },
    {
      icon: 'fas fa-brain',
      title: 'Behavioral Insights',
      description: 'The AI learns from your notes to spot hidden patterns, like "When you feel extremely confident, you tend to buy high," helping you avoid costly mistakes.',
      gradient: 'linear-gradient(135deg, #00D4FF, #FF0099)'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <section id="features" className="features">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Powerful Features</h2>
          <p className="section-subtitle">
            Advanced AI technology meets professional trading expertise
          </p>
        </motion.div>
        
        <motion.div 
          ref={ref}
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {features.map((feature, index) => (
            <motion.div 
              key={index} 
              className="feature card"
              variants={itemVariants}
            >
              <div 
                className="feature-icon"
                style={{ background: feature.gradient }}
              >
                <i className={feature.icon}></i>
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
